<template>
    <div>
        <el-row type="flex" justify="center">
            <!-- <el-col :sm="12">
                <el-card
                    class="box-card text-md-left"
                    shadow="never"
                    style="margin-bottom:10px;"
                    :body-style="{'background-color': 'white', 'color': 'black', 'padding': '5px 5px'}">
                    <div slot="header" class="text-md-center">ข้อมูลผู้ใช้ที่เลือก</div>
                    <p>รหัสลูกค้า: {{userInfo.userCode}}</p>
                    <p>ชื่อลูกค้า: {{userInfo.userName}}</p>
                </el-card>
            </el-col> -->
        </el-row>
        <el-row>
            <el-col class="text-md-left" :sm="24">
                <el-form :inline="true" @submit.native.prevent="() => {}">
                    <el-form-item class="txt_searchText">
                        <el-input
                            placeholder="ค้นหา"
                            clearable
                            @keypress.enter.native="seachShop()"
                            @input="seachShop"
                            v-model="searchText">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="seachShop()">เรียกข้อมูล</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col class="text-md-left" :span="24">
                <el-table
                    v-loading="loadingTable"
                    :data="shopList"
                    stripe
                    :header-cell-style="{'background-color': 'black', 'color': 'white', 'text-align': 'center'}"
                    style="width: 100%">
                    <el-table-column fixed label="ชื่อร้าน" width="180">
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.deletedAt ? 'red' : '' }">{{scope.row.name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="รหัสร้านค้า" min-width="100">
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.deletedAt ? 'red' : '' }">{{scope.row.shopId}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="อีเมล์ร้าน" min-width="180">
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.deletedAt ? 'red' : '' }">{{scope.row.email}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="เบอร์โทรร้าน" width="180">
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.deletedAt ? 'red' : '' }">{{scope.row.phoneNumber}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goodsType" label="ประเภทสินค้าในร้าน" width="180">
                        <template slot-scope="scope">
                             <span :style="{'color': scope.row.deletedAt ? 'red' : '' }">{{getShopGoodsType(scope.row.goodsType)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createdAt" label="สร้างเมื่อ" width="150">
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.deletedAt ? 'red' : '' }">{{scope.row.createdAt | dayjs('format', 'YYYY-MM-DD HH:mm:ss')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="ลบ" width="150">
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.deletedAt ? 'red' : '' }"> {{scope.row.deletedAt? $dayjs(scope.row.deletedAt).format('DD/MM/YYYY HH:mm:ss') : '-'}}</span>

                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="จัดการ" width="80">
                        <template slot-scope="scope">
                            <!-- <el-button :key="scope.$index" size="small" icon="el-icon-edit" type="warning" plain @click="showShopDetail(scope.row)"></el-button> -->
                            <el-button :key="scope.$index" size="small" icon="el-icon-edit" type="primary" plain @click="showShopDetail(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col style="margin-top:10px;">
                <el-pagination
                    @size-change="changeLimitPage"
                    @current-change="changeCurrentPage"
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="10"
                    layout="prev, pager, next, sizes"
                    :total="pagination.allPage * pagination.limit">
                </el-pagination>
            </el-col>
        </el-row>
        <!-- <modal-shop-detail
            :dialogShow="dialogShopShow"
            :shopObj="shopInfoSel"
            :shopIds="shopIds"
            @closeModal="onCloseDialog"
            @evenFetchShopList="onRefreshShopList"
            ></modal-shop-detail> -->
            <modal-shop-detail-re :data.sync="shopDetailDialog"
            :geoHierarchyData="geoHierarchyData"
            :provinceArray="provinceArray"
            :zipcodeArray="zipcodeArray"
            @close="closeDialogShopInfo"
            />
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import ModalShopDetailRe from '@/components/Shop/DialogShop'

export default {
    name: 'ShopListTable',
    components: {
        ModalShopDetailRe
    },
    props: {
        userID: {
            type: String,
            default: null
        },
        componentKey: {
            type: Number,
            default: 0
        },
        userInfo: {
            type: Object,
            default: () => {
                return { userCode: '-', userName: '-' }
            }
        },
        provinceArray: {
            type: Array,
            default: null
        },
        geoHierarchyData: {
            type: Object,
            default: null
        },
        zipcodeArray: {
            type: Array,
            default: null
        }
    },
    data () {
        const options = []
        for (let i = 0; i <= 10000; i++) {
            options.push('Opt ' + i)
        }
        return {
            searchText: '',
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            shopList: [],
            loadingTable: false,
            dialogShopShow: false,
            shopInfoSel: null,
            shopIds: [],
            timeoutSearch: null,
            shopDetailDialog: {
                dialogVisible: false,
                shopDetail: {}
            },
            model: null,
            options
        }
    },
    watch: {
        componentKey (val) {
            this.searchText = ''
            this.pagination = {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            }
            this.fetchListShop(this.userID)
        }
    },
    methods: {
        changeLimitPage (val) {
            this.pagination.limit = val
            if (this.userID) {
                this.fetchListShop(this.userID)
            } else {
                this.fetchListShop()
            }
        },
        changeCurrentPage (val) {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            console.log(this.userID)
            if (this.userID) {
                this.fetchListShop(this.userID)
            } else {
                this.fetchListShop()
            }
        },
        seachShop (val) {
            // console.log(val)
            this.$emit('setUserId')
            this.pagination.currentPage = 1
            this.pagination.offset = 0
            this.fetchListShop()
        },
        closeDialogShopInfo () {
            if (this.userID) {
                this.fetchListShop(this.userID)
            } else {
                this.fetchListShop()
            }
        },
        async fetchListShop (name = null) {
            // if (this.userID === '') {
            //     return
            // }
            clearTimeout(this.timeoutSearch)
            this.timeoutSearch = setTimeout(async () => {
                this.loadingTable = true
                let param = {
                    target_user_id: name,
                    search: this.searchText,
                    limit: this.pagination.limit,
                    offset: this.pagination.offset,
                    is_approve: true
                }
                console.log(param)
                let res = await fgApi.shop.searchListShop(param)
                console.log(res)
                // this.shopIds = res.data.map(e => e.shopId)
                // console.log(e.shopId, e.name)
                this.shopIds = []
                res.data.forEach(e => this.shopIds.push({ shopId: String(e.shopId), shopName: e.name }))
                if (this.searchText === param.search) {
                    this.shopList = res.data
                    this.pagination.allPage = res.allPage
                }
                this.loadingTable = false
            }, 500)
        },
        showShopDetail (shopObj) {
            Object.entries(shopObj.financeConfig).forEach(e => {
                shopObj.financeConfig[e[0]]['zipcodeArr'] = []
                Object.entries(shopObj.financeConfig[e[0]].remoteZone).forEach(s => {
                    if (s[0] !== 'cost') {
                        shopObj.financeConfig[e[0]].zipcodeArr.push(s[0])
                    }
                })
            })
            if (shopObj.bankName === 0) {
                shopObj.bankName = null
            }
            this.shopDetailDialog.dialogVisible = !this.shopDetailDialog.dialogVisible
            this.shopDetailDialog.shopDetail = JSON.parse(JSON.stringify(shopObj))
        },
        onCloseDialog () {
            this.shopInfoSel = null
            this.dialogShopShow = false
        },
        onRefreshShopList (val) {
            console.log('user Id ;', val)
            this.fetchListShop(val)
        }
    }
}
</script>

<style lang="scss" scoped>
.txt_searchText {
    div {
        width: 500px !important;
    }
}
.box-card {
    background-color:black !important;
    color:white !important;
    div.el-card__header {
        background-color:black !important;
        color:white !important;
        padding: unset !important;
    }
}
</style>
